import { Chart, registerables } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useRef } from "react";

import { formatNumber } from "utils/formatNumber";

Chart.register(...registerables);

const formatData = ({
  data,
  backgroundColor,
  barThickness,
  borderWidth,
  borderColor,
} = {}) => {
  const modifiedDatasets = data?.datasets?.map((el) => ({
    borderWidth: { left: borderWidth, right: borderWidth },
    borderSkipped: false,
    backgroundColor,
    barThickness,
    borderColor,
    datalabels: {
      anchor: "end",
      align: "end",
      formatter: function (value) {
        return formatNumber.toAmount(value?.x ?? value);
      },
    },
    showLegend: true,
    ...el,
  }));

  return {
    labels: data?.labels,
    datasets: modifiedDatasets,
  };
};

const GroupVerticalBarChart = (props) => {
  const {
    data = [],
    height = 250,
    id = "bar-chart",
    barThickness = 24,
    borderRadius = 8,
    borderWidth = 4,
    dataBgColor = "#FFB703",
    borderColor = "transparent",
  } = props;

  const chartRef = useRef(null);

  useEffect(() => {
    const createChart = (chartData) => {
      const ctx = document.getElementById(id)?.getContext("2d");
      chartRef.current = new Chart(ctx, {
        type: "bar",
        data: chartData,
        plugins: [ChartDataLabels],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          elements: {
            bar: {
              borderRadius,
              borderSkipped: false,
            },
          },
          plugins: {
            legend: {
              display: false,
            },
          },
          scales: {
            x: {
              border: {
                color: "#ECECEC",
                width: 2,
              },
              grid: {
                drawOnChartArea: false,
                drawTicks: false,
              },
            },
            y: {
              grace: "30%",
              border: {
                color: "#ECECEC",
                width: 2,
              },
              position: "left",
              beginAtZero: true,
              ticks: {
                stepSize: 50,
                callback: (value) => {
                  return formatNumber.toMioBioTio(value);
                },
              },
              grid: {
                lineWidth: 2,
                drawTicks: false,
              },
            },
          },
        },
      });
    };

    if (chartRef.current) {
      chartRef.current.destroy();
    }

    createChart(
      formatData({
        data,
        backgroundColor: dataBgColor,
        barThickness,
        borderWidth,
        borderColor,
      }),
    );

    return () => {
      chartRef.current.destroy();
    };
  }, [
    barThickness,
    borderRadius,
    data,
    dataBgColor,
    id,
    height,
    borderWidth,
    borderColor,
  ]);

  return (
    <div className='w-full'>
      <canvas id={id} width='400' height={height}></canvas>
    </div>
  );
};

export default GroupVerticalBarChart;
